export class FlightOverride {
  constructor( flight = {} ) {
    this.id = flight.id;
		this.estimated = flight.overrides.estimated;
		this.boarding = flight.overrides.boarding;
		this.gate = flight.overrides.gate;
		this.claim = flight.overrides.claim;
		this.checkIn = flight.overrides.checkIn;
		this.status = flight.overrides.status;
		this.languages = flight.overrides.languages;
    this.remarks = flight.overrides.remarks;
	}
	
	restore() {
		this.estimated = null;
		this.boarding = null;
		this.gate = null;
		this.claim = null;
		this.checkIn = null;
		this.status = null;
		this.languages = null;
    this.remarks = null;
	}

}